export const NewKYCFormHTMLTemplate = `
<html>

<head>
<link rel="stylesheet" href="styles.css"/>
<link href="https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap" rel="stylesheet">
<style>

:root {
  --colors-foreground-fg-secondary-700: #344054;
  --colors-border-border-secondary: #eaecf0;
  --colors-text-secondary: #344054;
  --colors-foreground-fg-primary-900: #101828;
  --colors-background-bg-brand-section-subtle: #635235;
  --colors-background-secondaryColor_bg_hover: #F4F1ED;
  --component-colors-utility-gray-utility-gray-100: #f2f4f7;
  --colors-foreground-fg-brand-tertiary-600: #7F6944;
  --colors-background-brand-solid: #7F6944;
}
body{font-family:"Inter"}
.show {
  display: block !important;
  margin-bottom: 32px;
}

.hide {
  display: none;
}

.actions {
  display: flex;
  grid-gap: 12px;
  gap: 12px;
  justify-content: flex-end;
  padding: 0 32px 32px;

  .approveButton, .rejectButton {
    padding: 10px var(--spacing-xl, 16px);
    border-radius: var(--radius-md, 8px);
    border: 1px solid var(--Component-colors-Components-Buttons-Primary-button-primary-border, #7F6944);
    background: var(--Component-colors-Components-Buttons-Primary-button-primary-bg, #7F6944);
    color: var(--Component-colors-Components-Buttons-Primary-button-primary-fg, #FFF);
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }

  .rejectButton {
    border: 1px solid var(--Component-colors-Components-Buttons-Secondary-button-secondary-border, #D0D5DD);
    background: var(--Component-colors-Components-Buttons-Secondary-button-secondary-bg, #FFF);
    color: var(--Component-colors-Components-Buttons-Secondary-button-secondary-fg, #344054);
  }
}

.newLayoutClass {

    input:not([type="checkbox"]):not([type="radio"]) {
      height: 24px !important;
      width: 100% !important;
      border-radius: var(--radius-md, 8px);
      border: 1px solid var(--Colors-Border-border-primary, #D0D5DD);
      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
      padding: 8px;
    }

    input[type="checkbox"]{
        accent-color: #7F6944 !important;
    }


    .radio-btn-group input {
      accent-color: #7F6944 !important;
    }

    .KycForm {
      .Form_Table {
        font-family: inter;
        width: 100%;
        table-layout: fixed;
        margin-inline: unset;
        border-collapse: collapse;
      }
  
      .Nested_Table,
      .Dynamic_Table {
        width: 100%;
        table-layout: fixed;
        margin-bottom: 16px;
  
        &.tow-col-table {
          table-layout: auto;
          td:nth-of-type(2) {
            width: 65%;
            padding: 11px;
          }
        }
      }
  
      th,
      td {
        border: 1px solid var(--colors-border-border-secondary);
      }
  
      td {
        padding: 0;
        font-size: 16px;
        font-weight: 400;
        color: var(--colors-foreground-fg-primary-900);
        line-height: 24px;
        overflow: hidden;
      }
  
      .Spaced_Table_Header {
        th {
          align-items: center;
          display: flex;
          justify-content: space-between;
          padding: 12px;
          background-color: var(--colors-background-secondaryColor_bg_hover);
          color: unset;
          border-radius: 4px;
          border-color: transparent;
        }
  
        .Header_Title {
          display: block;
          font-size: 20px;
          font-weight: 600;
          line-height: 30px;
          color: var(--colors-background-bg-brand-section-subtle);
        }
        .Header_Sub_Title {
          display: block;
          font-size: 16px;
          font-weight: 400;
          color: var(--colors-foreground-fg-brand-tertiary-600);
        }
        .Header_Button {
          display: none;
        }
      }
  
      .Space_After {
        &::after {
          content: "";
          display: block;
          height: 16px;
          background-color: transparent;
        }
      }
      .Row_Text {
        border: unset;
        padding: 15px 0px;
      }
  
      .Dynamic_Table {
        th {
          padding: 8px 20px;
          font-weight: 400;
          font-size: 16px;
          color: var(--colors-foreground-fg-primary-900);
        }
      }
  
      //Components_Style_Override
      .Cell_Value {
        padding: 12px;
  
        .autocomplete-wrapper,
        .text-field-wrapper {
          height: 18px;
        }
        .MuiInputBase-root {
          min-height: 20px !important;
          display: flex;
          width: 100% !important;
        }
        .MuiFormControl-root {
          margin: 0px !important;
          padding: 0px !important;
          margin-bottom: 0px !important;
        }

        .radio-group-wrapper {
          .MuiFormControlLabel-label {
            font-size: 14px;
            color: var(--colors-text-secondary) !important;
          }
          &.Mui-checked {
            .radio-icon,
            + .MuiTypography-root {
              color: var(--colors-background-brand-solid);
            }
          }
          .Mui-checked .radio-icon {
            border-color: var(--colors-background-brand-solid) !important;
            color: var(--colors-background-brand-solid) !important;
          }
        }
  
        .-groups-wrapper .MuiFormControlLabel-label {
          font-size: 16px !important;
          padding: 4px;
          color: var(--colors-foreground-fg-secondary-700);
        }
      }

      .MuiInputBase-root {
        min-height: 20px !important;
        display: flex;
        width: 100% !important;
      }
  
      #signature_text_Ref {
        width: 94% !important;

      }

      .signature_input {
        border: none;
        position: relative;
        color: #8c8c8c;
        background-color: #f2f4f7;
        font-weight: 400;
        margin-bottom: 12px;
        padding-bottom: 12px;
      }
  
      .signature_input::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border: 0.717px solid transparent;
        border-image: repeating-linear-gradient(
          140deg,
          #98a2b3 0,
          #98a2b3 5px,
          transparent 5px,
          transparent 10px
        );
        border-image-slice: 1;
        pointer-events: none;
      }

      .signature_button {
        align-items: center;
        background: rgb(127, 105, 68);
        border-radius: 8px;
        border: 1px solid;
        box-shadow: none;
        color: rgb(255, 255, 255);
        cursor: pointer;
        display: flex;
        font-size: 12px;
        font-weight: 600;
        justify-self: center;
        line-height: 20px;
        min-height: 36px;
        padding: 6px 10px;
        place-self: auto;
        width: auto;
        justify-self: center;
      }
    }

    .tow-col-table {
        margin-bottom: 16px;

      td {
        padding: 16px 20px;
      }
    }
  
    .MandatoryInformation {
      .Row_Text {
        p {
          font-size: 18px;
          font-weight: 700;
        }
  
        li {
          font-weight: 400;
          font-size: 16px;
        }
      }
    }
  
    .Confirmation,
    .ForOfficeUseOnly {
      .Row_Text {
        p {
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  
    .Gray_Cell_Value {
      background-color: var(--component-colors-utility-gray-utility-gray-100);
      height: 40px;
    }
  
    .individualKycForm {
      td {
        padding: 12px;
      }
    }
  
    .Dynamic_Table {
      td {
        padding: 0 12px;
      }
  
      .Cell_Value {
        padding: 12px 0;
      }
    }

    .selectedCount {
      color: var(--colors-background-bg-brand-section-subtle);
      font-weight: 600;
      font-size: 16px;
    }
  
    .add_Record {
      display: flex;
      gap: 12px;
      align-items: center;
      cursor: pointer;

      button {
        border: none;
        background: transparent;
        padding: 0;
      }
    }

    .padding_12 {
      padding: 12px !important;
    }

    .solid {
        color: rgb(255, 255, 255);
        width: auto;
        display: flex;
        padding: 8px 12px;
        font-size: 14px;
        background: rgb(127, 105, 68);
        box-shadow: none;
        min-height: 36px;
        align-items: center;
        font-weight: 600;
        line-height: 20px;
        border-radius: 8px;
    }

    .outlined {
      color: rgb(52, 64, 84);
      width: auto;
      border: 1px solid rgb(208, 213, 221);
      display: flex;
      padding: 8px 12px;
      font-size: 14px;
      background: rgb(255, 255, 255);
      box-shadow: none;
      min-height: 36px;
      align-items: center;
      font-weight: 600;
      line-height: 20px;
      border-radius: 8px;
    }
  }
@page { margin: 0; }
@media print {body{-webkit-print-color-adjust:exact; margin: 0; padding: 0;  }}
</style>

</head>

<body>
<div id="psiAssetsLogo" class="hide">
<svg width="85" height="76" viewBox="0 0 85 76" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Psi Logo-02 1" clip-path="url(#clip0_22230_352043)">
<path id="Vector" d="M54.9665 16.3926V17.2548C57.3225 18.1039 57.6842 19.9882 57.6763 24.9701L57.6186 61.9638C57.6134 66.2014 61.0439 69.6424 65.2789 69.6503H65.7742L65.845 24.9832C65.8528 19.9305 66.2145 18.0593 68.6439 17.2338V16.4135L54.9639 16.3926H54.9665Z" fill="#282964"/>
<path id="Vector_2" d="M27.0848 27.9947C25.2163 28.6891 23.4945 29.7296 22.0112 31.0609C20.617 32.3293 19.4901 33.8597 18.696 35.5684C17.0267 39.4287 17.1026 43.821 18.9109 47.621C19.8596 49.521 21.2381 51.1747 22.9363 52.4483C24.6869 53.8373 27.913 55.7897 32.6197 58.3055C34.4359 59.2437 36.2022 60.2763 37.9135 61.3953C39.2815 62.2575 40.5709 63.2377 41.7712 64.3227C42.5889 65.0302 43.2493 65.9003 43.7157 66.8752C44.0643 67.6902 44.2399 68.5682 44.2399 69.4566C44.2399 70.4682 44.0014 71.464 43.5428 72.3629C43.0606 73.3011 42.4185 74.1424 41.6349 74.85C41.2366 75.209 40.8015 75.5313 40.3403 75.8091C50.9095 76.1656 53.2524 67.4806 49.6359 61.1726C47.5262 57.4853 42.7225 54.9537 39.1191 52.7575C37.9031 52.0185 37.6698 51.8586 36.3568 51.0672C35.0465 50.2784 33.841 49.5629 32.7115 48.8973C31.6003 48.229 30.6568 47.6551 29.8706 47.1912C29.0844 46.709 28.6048 46.4181 28.4188 46.308C27.1189 45.3384 26.0287 44.1171 25.2084 42.7177C24.548 41.5567 24.1942 40.2464 24.1811 38.9124C24.1811 37.8301 24.4222 36.7609 24.8809 35.7781C25.3552 34.7665 26.0366 33.8624 26.8778 33.1233C27.8213 32.324 28.9089 31.7108 30.0803 31.3203C31.4483 30.8564 32.8871 30.6284 34.3311 30.6468C36.9151 30.6127 39.4702 31.2207 41.7607 32.421C42.8142 32.9635 43.7996 33.6291 44.6933 34.4049C45.5214 35.1282 46.2342 35.9746 46.8029 36.9129C47.4371 37.9978 47.9324 39.1562 48.2836 40.3617C48.7553 41.9393 49.1249 43.5458 49.3895 45.1706H51.0956L51.1244 26.9071H49.4184C49.3686 27.7378 49.0829 28.5398 48.5955 29.2211C48.2102 29.6169 47.6651 29.8265 47.1122 29.7898C46.5566 29.7479 46.0062 29.6457 45.4742 29.4806C44.7169 29.2631 43.742 28.9643 42.5391 28.6105C39.2946 27.6513 36.328 26.8415 33.2566 26.8389C31.2806 26.8337 29.2548 27.1639 27.0822 27.9999" fill="#282964"/>
<path id="Vector_3" d="M18.5727 0.212418L0.130921 0.183594V1.07463C0.807058 1.34718 1.38885 1.6669 1.83437 2.19628C2.55768 3.07683 2.90885 6.06966 2.90361 9.14373L2.84595 46.1348C2.84071 48.9913 2.54458 52.1257 1.97065 52.9617C1.50417 53.6483 0.848985 53.9654 0.0444336 54.2956V55.0923L13.3182 55.1133C13.0535 54.7018 12.8124 54.272 12.5923 53.8317C12.1048 52.8542 11.7458 51.8191 11.5204 50.7498C11.1745 49.2429 11.0251 47.6941 11.0828 46.1505L11.1168 26.4586L11.1535 3.50138C13.3497 2.93793 15.6166 2.66538 17.8887 2.69421C19.9748 2.668 22.053 2.96152 24.0499 3.57214C25.6695 4.06221 27.1764 4.85366 28.4946 5.91242C29.6372 6.83228 30.5545 8.00111 31.1756 9.3298C32.7768 12.797 32.4859 17.0294 29.5979 19.6632C34.5825 23.3374 37.8872 21.799 39.2316 18.0934C40.6835 13.9081 39.8108 9.26952 36.9411 5.8967C36.0999 4.91394 35.125 4.05435 34.0426 3.34152C32.8607 2.58414 31.5766 1.99187 30.2295 1.5909C28.5732 1.10083 26.8777 0.75752 25.1637 0.563589C23.1117 0.332968 21.044 0.215038 18.9789 0.212418C18.8426 0.212418 18.7037 0.212418 18.5675 0.212418" fill="#282964"/>
<g id="Group">
<g id="Group_2">
<path id="Vector_4" d="M80.2506 69.2232V57.8415L78.6782 56.3896V70.0592C78.6782 70.0592 79.3544 70.0644 80.2533 69.7761V69.2258L80.2506 69.2232Z" fill="#282964"/>
<path id="Vector_5" d="M82.7271 60.8369L82.7035 61.6231C82.7035 61.6231 85.395 64.3434 82.3235 67.8918L82.3 59.6288L80.7275 58.1533L80.7511 68.5889V69.5952C81.7286 69.189 82.8503 68.4317 83.6548 67.0113C83.6548 67.0113 85.7016 63.8402 82.7271 60.8395V60.8369Z" fill="#E35F27"/>
</g>
<g id="Group_3">
<path id="Vector_6" d="M77.1061 69.2232V57.8415L78.6786 56.3896V70.0592C78.6786 70.0592 78.0024 70.0644 77.1035 69.7761V69.2258L77.1061 69.2232Z" fill="#282964"/>
<path id="Vector_7" d="M74.6294 60.8369L74.653 61.6231C74.653 61.6231 71.9616 64.3434 75.033 67.8918L75.0566 59.6288L76.629 58.1533L76.6054 68.5889V69.5952C75.6279 69.189 74.5062 68.4317 73.7017 67.0113C73.7017 67.0113 71.6549 63.8402 74.6294 60.8395V60.8369Z" fill="#E35F27"/>
</g>
</g>
<g id="Group_4">
<path id="Vector_8" d="M81.6814 47.707V48.5981C81.6814 48.7003 81.6552 48.7841 81.6054 48.8497C81.5556 48.9152 81.4901 48.9623 81.4089 48.9912L79.598 49.683V53.1266L81.4089 53.8185C81.477 53.8447 81.5399 53.8919 81.5976 53.96C81.6552 54.0281 81.6814 54.112 81.6814 54.2116V55.1052L73.8691 51.9919V50.823L81.6814 47.7097V47.707ZM78.7698 49.9975L75.7403 51.1559C75.5333 51.2397 75.2738 51.3236 74.9567 51.4074C75.1114 51.4468 75.2581 51.4887 75.3918 51.5306C75.5254 51.5726 75.646 51.6119 75.7508 51.6538L78.7698 52.8069V50.0001V49.9975Z" fill="#282964"/>
<path id="Vector_9" d="M75.1403 42.4735C75.2032 42.5102 75.2477 42.5469 75.2766 42.5888C75.3054 42.6282 75.3211 42.6806 75.3211 42.7409C75.3211 42.8064 75.2923 42.8797 75.232 42.9636C75.1717 43.0475 75.1062 43.1523 75.0302 43.2755C74.9568 43.4013 74.8887 43.5506 74.8284 43.7236C74.7681 43.8966 74.7393 44.1062 74.7393 44.3499C74.7393 44.5779 74.7681 44.7797 74.8284 44.9501C74.8887 45.1231 74.9699 45.2672 75.0721 45.3825C75.1743 45.4978 75.2975 45.5869 75.4364 45.6472C75.5753 45.7075 75.7273 45.7363 75.8898 45.7363C76.0994 45.7363 76.275 45.6839 76.4113 45.5764C76.5476 45.469 76.6682 45.3301 76.7651 45.1545C76.8621 44.9815 76.9486 44.7824 77.0219 44.5622C77.0953 44.3421 77.1687 44.1141 77.2473 43.8808C77.3259 43.6476 77.415 43.4222 77.5173 43.1995C77.6195 42.9793 77.7479 42.7802 77.8999 42.6072C78.0545 42.4342 78.2432 42.2927 78.4659 42.1852C78.6887 42.0778 78.9613 42.0254 79.2836 42.0254C79.6295 42.0254 79.9519 42.0831 80.2532 42.201C80.5546 42.3189 80.8167 42.4893 81.0421 42.7146C81.2674 42.94 81.443 43.2152 81.5715 43.5454C81.6999 43.873 81.7654 44.2477 81.7654 44.6644C81.7654 44.916 81.7418 45.1571 81.692 45.393C81.6422 45.6289 81.5741 45.8516 81.485 46.0613C81.3959 46.2709 81.2884 46.4675 81.1626 46.6509C81.0368 46.8344 80.8979 46.9995 80.7407 47.1436L80.1851 46.8108C80.1405 46.7767 80.1065 46.74 80.075 46.6928C80.0436 46.6457 80.0305 46.5959 80.0305 46.5382C80.0305 46.4622 80.0698 46.3731 80.151 46.2735C80.2296 46.174 80.3188 46.0508 80.4157 45.904C80.5127 45.7573 80.5992 45.5817 80.6804 45.3773C80.759 45.1729 80.801 44.9239 80.801 44.6304C80.801 44.3919 80.7695 44.177 80.7066 43.9883C80.6437 43.7996 80.552 43.6397 80.4341 43.5113C80.3162 43.3829 80.1746 43.2833 80.0069 43.2152C79.8392 43.1471 79.6557 43.113 79.4513 43.113C79.2233 43.113 79.0373 43.1654 78.8905 43.2702C78.7464 43.375 78.6232 43.514 78.5262 43.6895C78.4292 43.8625 78.3454 44.0617 78.2746 44.2818C78.2065 44.5019 78.1331 44.7299 78.0597 44.9632C77.9863 45.1964 77.8999 45.4218 77.8003 45.6446C77.7033 45.8647 77.5749 46.0639 77.4177 46.2368C77.2604 46.4098 77.0613 46.5513 76.8254 46.6562C76.5869 46.761 76.296 46.8134 75.9475 46.8134C75.6671 46.8134 75.3971 46.7584 75.1376 46.6509C74.8756 46.5408 74.645 46.3836 74.4432 46.1739C74.2414 45.9643 74.0815 45.7075 73.9583 45.4035C73.8378 45.0995 73.7749 44.7509 73.7749 44.3578C73.7749 43.9202 73.8457 43.5166 73.9846 43.1471C74.1235 42.7802 74.3252 42.4578 74.5847 42.1879L75.135 42.4709L75.1403 42.4735Z" fill="#282964"/>
<path id="Vector_10" d="M75.1403 36.3352C75.2032 36.3719 75.2477 36.4085 75.2766 36.4505C75.3054 36.4924 75.3211 36.5422 75.3211 36.6025C75.3211 36.668 75.2923 36.7414 75.232 36.8252C75.1717 36.9091 75.1062 37.0139 75.0302 37.1371C74.9568 37.2629 74.8887 37.4123 74.8284 37.5852C74.7681 37.7582 74.7393 37.9679 74.7393 38.2116C74.7393 38.4396 74.7681 38.6414 74.8284 38.8117C74.8887 38.9847 74.9699 39.1288 75.0721 39.2441C75.1743 39.3594 75.2975 39.4485 75.4364 39.5088C75.5753 39.5691 75.7273 39.5979 75.8898 39.5979C76.0994 39.5979 76.275 39.5455 76.4113 39.4381C76.5502 39.3306 76.6682 39.1917 76.7651 39.0161C76.8621 38.8432 76.9486 38.644 77.0219 38.4239C77.0953 38.2037 77.1687 37.9757 77.2473 37.7425C77.3259 37.5092 77.415 37.2838 77.5173 37.0637C77.6195 36.8436 77.7479 36.6444 77.8999 36.4714C78.0545 36.2985 78.2432 36.157 78.4659 36.0495C78.6887 35.9421 78.9613 35.8896 79.2836 35.8896C79.6295 35.8896 79.9519 35.9473 80.2532 36.0652C80.5546 36.1832 80.8167 36.3535 81.0421 36.5789C81.2674 36.8043 81.443 37.0794 81.5715 37.4096C81.6999 37.7372 81.7654 38.1094 81.7654 38.5287C81.7654 38.7803 81.7418 39.0214 81.692 39.2572C81.6422 39.4931 81.5741 39.7158 81.485 39.9255C81.3959 40.1352 81.2884 40.3317 81.1626 40.5152C81.0368 40.6986 80.8979 40.8637 80.7407 41.0078L80.1851 40.675C80.1405 40.641 80.1065 40.6043 80.075 40.5571C80.0436 40.5099 80.0305 40.4601 80.0305 40.4025C80.0305 40.3265 80.0698 40.2374 80.151 40.1378C80.2296 40.0382 80.3188 39.915 80.4157 39.7683C80.5127 39.6215 80.5992 39.4459 80.6804 39.2415C80.759 39.0371 80.801 38.7881 80.801 38.4946C80.801 38.2561 80.7695 38.0412 80.7066 37.8525C80.6437 37.6639 80.552 37.504 80.4341 37.3756C80.3162 37.2472 80.1746 37.1476 80.0069 37.0794C79.8392 37.0113 79.6557 36.9772 79.4513 36.9772C79.2233 36.9772 79.0373 37.0296 78.8905 37.1345C78.7464 37.2393 78.6232 37.3782 78.5262 37.5538C78.4292 37.7267 78.3454 37.9259 78.2746 38.1461C78.2065 38.3662 78.1331 38.5942 78.0597 38.8274C77.9863 39.0607 77.8999 39.2861 77.8003 39.5088C77.7033 39.729 77.5749 39.9281 77.4177 40.1011C77.2604 40.2741 77.0613 40.4156 76.8254 40.5204C76.5869 40.6252 76.296 40.6776 75.9475 40.6776C75.6671 40.6776 75.3971 40.6226 75.1376 40.5152C74.8756 40.4051 74.645 40.2479 74.4432 40.0382C74.2414 39.8285 74.0815 39.5717 73.9583 39.2677C73.8378 38.9637 73.7749 38.6152 73.7749 38.2221C73.7749 37.7844 73.8457 37.3808 73.9846 37.0113C74.1235 36.6444 74.3252 36.3221 74.5847 36.0521L75.135 36.3352H75.1403Z" fill="#282964"/>
<path id="Vector_11" d="M80.7406 29.3932L81.6814 29.3985V34.2415H73.8691V29.3985H74.81V33.0753H77.2865V30.1166H78.1959V33.0753H80.7432V29.3906L80.7406 29.3932Z" fill="#282964"/>
<path id="Vector_12" d="M74.8364 22.417V24.8988H81.6816V26.0519H74.8364V28.5442H73.8667V22.417H74.8364Z" fill="#282964"/>
<path id="Vector_13" d="M75.1403 17.0578C75.2032 17.0945 75.2477 17.1312 75.2766 17.1731C75.3054 17.2151 75.3211 17.2648 75.3211 17.3251C75.3211 17.3906 75.2923 17.464 75.232 17.5479C75.1717 17.6317 75.1062 17.7366 75.0302 17.8597C74.9568 17.9855 74.8887 18.1349 74.8284 18.3079C74.7681 18.4808 74.7393 18.6905 74.7393 18.9342C74.7393 19.1622 74.7681 19.364 74.8284 19.5344C74.8887 19.7073 74.9699 19.8515 75.0721 19.9668C75.1743 20.0821 75.2975 20.1712 75.4364 20.2315C75.5753 20.2918 75.7273 20.3206 75.8898 20.3206C76.0994 20.3206 76.275 20.2682 76.4113 20.1607C76.5502 20.0533 76.6682 19.9144 76.7651 19.7388C76.8621 19.5658 76.9486 19.3666 77.0219 19.1465C77.0953 18.9264 77.1687 18.6984 77.2473 18.4651C77.3259 18.2319 77.415 18.0065 77.5173 17.7864C77.6195 17.5662 77.7479 17.3671 77.8999 17.1941C78.0545 17.0211 78.2432 16.8796 78.4659 16.7722C78.6887 16.6647 78.9613 16.6123 79.2836 16.6123C79.6295 16.6123 79.9519 16.67 80.2532 16.7879C80.5546 16.9058 80.8167 17.0762 81.0421 17.3015C81.2674 17.5269 81.443 17.8021 81.5715 18.1323C81.6999 18.4599 81.7654 18.832 81.7654 19.2513C81.7654 19.5029 81.7418 19.744 81.692 19.9799C81.6422 20.2157 81.5741 20.4385 81.485 20.6482C81.3959 20.8578 81.2884 21.0544 81.1626 21.2378C81.0368 21.4213 80.8979 21.5864 80.7407 21.7305L80.1851 21.3977C80.1405 21.3662 80.1065 21.3269 80.075 21.2797C80.0462 21.2352 80.0305 21.1828 80.0305 21.1251C80.0305 21.0491 80.0698 20.96 80.151 20.8604C80.2296 20.7609 80.3188 20.6377 80.4157 20.4909C80.5127 20.3442 80.5992 20.1686 80.6804 19.9642C80.759 19.7597 80.801 19.5108 80.801 19.2173C80.801 18.9788 80.7695 18.7639 80.7066 18.5752C80.6437 18.3865 80.552 18.2266 80.4341 18.0982C80.3162 17.9698 80.1746 17.8702 80.0069 17.8021C79.8392 17.734 79.6557 17.6999 79.4513 17.6999C79.2233 17.6999 79.0373 17.7523 78.8905 17.8571C78.7464 17.962 78.6232 18.1008 78.5262 18.2764C78.4292 18.4494 78.3454 18.6486 78.2746 18.8687C78.2065 19.0889 78.1331 19.3169 78.0597 19.5475C77.9863 19.7807 77.8999 20.0061 77.8003 20.2289C77.7033 20.449 77.5749 20.6482 77.4177 20.8211C77.2604 20.9941 77.0613 21.1356 76.8254 21.2404C76.5869 21.3453 76.296 21.3977 75.9475 21.3977C75.6671 21.3977 75.3971 21.3426 75.1376 21.2352C74.8756 21.1277 74.645 20.9679 74.4432 20.7582C74.2414 20.5486 74.0815 20.2917 73.9583 19.9877C73.8378 19.6837 73.7749 19.3352 73.7749 18.9421C73.7749 18.5044 73.8457 18.1009 73.9846 17.7313C74.1235 17.3644 74.3252 17.0421 74.5847 16.7722L75.135 17.0552L75.1403 17.0578Z" fill="#282964"/>
</g>
</g>
<defs>
<clipPath id="clip0_22230_352043">
<rect width="84.3862" height="76" fill="white"/>
</clipPath>
</defs>
</svg>
</div>

<div id="psiInvestmentLogo" class="hide">
<svg width="171" height="76" viewBox="0 0 171 76" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="blue logo 1" clip-path="url(#clip0_22237_352244)">
<g id="Group">
<g id="Group_2">
<path id="Vector" d="M82.5593 18.8923H83.4621C83.7196 18.8923 85.1608 19.0127 85.2143 20.8853C85.2712 22.6776 83.9537 22.7177 83.4722 22.7177H82.5493L82.556 18.8923H82.5593ZM81.2686 26.9912H82.5459L82.5526 23.1692C83.8868 23.1692 86.5954 23.3364 86.5987 20.8853C86.6021 18.5212 84.044 18.4844 82.673 18.4844C82.6329 18.4844 82.5927 18.4844 82.5593 18.4844H81.2819L81.2686 26.9912Z" fill="#E25F26"/>
<g id="Clip path group">
<mask id="mask0_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="81" y="18" width="6" height="9">
<g id="clippath">
<path id="Vector_2" d="M82.5593 18.8923H83.4621C83.7196 18.8923 85.1608 19.0127 85.2143 20.8853C85.2712 22.6776 83.9537 22.7177 83.4722 22.7177H82.5493L82.556 18.8923H82.5593ZM81.2686 26.9912H82.5459L82.5526 23.1692C83.8868 23.1692 86.5954 23.3364 86.5987 20.8853C86.6021 18.5212 84.044 18.4844 82.673 18.4844C82.6329 18.4844 82.5927 18.4844 82.5593 18.4844H81.2819L81.2686 26.9912Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask0_22237_352244)">
<g id="Group_3">
<path id="Vector_3" d="M86.5957 18.3166L81.0073 18.4873L81.2723 27.1607L86.8607 26.9899L86.5957 18.3166Z" fill="#E25F26"/>
</g>
</g>
</g>
</g>
<path id="Vector_4" d="M88.8059 18.9025H89.7255C89.9796 18.9025 91.4108 19.0329 91.4676 20.8821C91.4676 21.0794 91.4542 21.2867 91.4208 21.474C91.3874 21.6278 91.3406 21.7749 91.2703 21.9154C91.2235 22.0324 91.1399 22.1494 91.0597 22.2397C90.9794 22.3333 90.8958 22.4036 90.8022 22.4738C90.6149 22.5875 90.3976 22.6577 90.1735 22.6911C90.0231 22.7145 89.8726 22.7246 89.7221 22.7246H88.8025L88.8092 18.8992L88.8059 18.9025ZM88.8092 18.4946H87.5285L87.5151 27.0014H88.7959L88.8025 23.1793C89.0801 23.1793 89.4044 23.1793 89.7555 23.1693L92.4674 27.0081H93.8986L91.0697 23.0657C92.0227 22.8216 92.8486 22.2431 92.852 20.8821C92.8553 18.5313 90.2973 18.4946 88.9263 18.4912H88.8126" fill="#E25F26"/>
<g id="Group_4">
<path id="Vector_5" d="M88.8088 18.9031H89.725C89.9792 18.9031 91.4104 19.0335 91.4672 20.8827C91.4672 21.0799 91.4538 21.2906 91.4204 21.4745C91.3869 21.6283 91.3401 21.7788 91.2666 21.9193C91.2198 22.0363 91.1395 22.15 91.0592 22.2436C90.9757 22.3372 90.8954 22.4075 90.8018 22.4777C90.6179 22.5914 90.3972 22.6616 90.1765 22.695C90.0327 22.7185 89.8855 22.7285 89.7384 22.7285H88.8055L88.8122 18.9031H88.8088ZM87.5181 27.002H88.7954L88.8021 23.1799C89.0797 23.1799 89.4074 23.1799 89.7518 23.1699L92.467 27.0087H93.8982L91.0659 23.0662C92.0189 22.8221 92.8449 22.2436 92.8482 20.8827C92.8516 18.5319 90.2935 18.4951 88.9225 18.4951C88.8824 18.4951 88.8422 18.4951 88.8088 18.4951H87.5281L87.5181 27.002Z" fill="#E25F26"/>
<g id="Clip path group_2">
<mask id="mask1_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="87" y="18" width="7" height="10">
<g id="clippath-1">
<path id="Vector_6" d="M88.8088 18.9031H89.725C89.9792 18.9031 91.4104 19.0335 91.4672 20.8827C91.4672 21.0799 91.4538 21.2906 91.4204 21.4745C91.3869 21.6283 91.3401 21.7788 91.2666 21.9193C91.2198 22.0363 91.1395 22.15 91.0592 22.2436C90.9757 22.3372 90.8954 22.4075 90.8018 22.4777C90.6179 22.5914 90.3972 22.6616 90.1765 22.695C90.0327 22.7185 89.8855 22.7285 89.7384 22.7285H88.8055L88.8122 18.9031H88.8088ZM87.5181 27.002H88.7954L88.8021 23.1799C89.0797 23.1799 89.4074 23.1799 89.7518 23.1699L92.467 27.0087H93.8982L91.0659 23.0662C92.0189 22.8221 92.8449 22.2436 92.8482 20.8827C92.8516 18.5319 90.2935 18.4951 88.9225 18.4951C88.8824 18.4951 88.8422 18.4951 88.8088 18.4951H87.5281L87.5181 27.002Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask1_22237_352244)">
<g id="Group_5">
<path id="Vector_7" d="M93.9047 18.2949L87.2568 18.498L87.5229 27.2048L94.1708 27.0017L93.9047 18.2949Z" fill="#E25F26"/>
</g>
</g>
</g>
</g>
<path id="Vector_8" d="M95.5234 22.7382C95.5301 20.0296 96.7506 18.7054 98.2386 18.7088C99.7401 18.7088 100.944 20.0162 100.941 22.7449C100.934 25.5571 99.7267 26.7742 98.2253 26.7742C96.7372 26.7742 95.5167 25.5504 95.5234 22.7382ZM94.1323 22.7348C94.1257 25.8145 95.9615 27.1655 98.2286 27.1688C100.496 27.1722 102.335 25.8279 102.338 22.7482C102.342 19.7487 100.509 18.3276 98.242 18.3242C95.9748 18.3209 94.1357 19.7588 94.1323 22.7348Z" fill="#E25F26"/>
<g id="Group_6">
<path id="Vector_9" d="M95.5234 22.7382C95.5267 20.0296 96.7506 18.7088 98.2386 18.7088C99.7367 18.7121 100.944 20.0162 100.937 22.7482C100.937 25.5571 99.7267 26.7776 98.2286 26.7776H98.2219C96.7372 26.7742 95.5167 25.5537 95.5201 22.7415M94.1323 22.7348C94.1257 25.8145 95.9614 27.1655 98.2253 27.1688C100.492 27.1688 102.332 25.8279 102.338 22.7448C102.342 19.7487 100.509 18.3276 98.242 18.3242C98.2386 18.3242 98.232 18.3242 98.2286 18.3242C95.9681 18.3242 94.1357 19.7621 94.1323 22.7348Z" fill="#E25F26"/>
<g id="Clip path group_3">
<mask id="mask2_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="94" y="18" width="9" height="10">
<g id="clippath-2">
<path id="Vector_10" d="M95.5234 22.7382C95.5267 20.0296 96.7506 18.7088 98.2386 18.7088C99.7367 18.7121 100.944 20.0162 100.937 22.7482C100.937 25.5571 99.7267 26.7776 98.2286 26.7776H98.2219C96.7372 26.7742 95.5167 25.5537 95.5201 22.7415M94.1323 22.7348C94.1257 25.8145 95.9614 27.1655 98.2253 27.1688C100.492 27.1688 102.332 25.8279 102.338 22.7448C102.342 19.7487 100.509 18.3276 98.242 18.3242C98.2386 18.3242 98.232 18.3242 98.2286 18.3242C95.9681 18.3242 94.1357 19.7621 94.1323 22.7348Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask2_22237_352244)">
<g id="Group_7">
<path id="Vector_11" d="M102.337 18.0597L93.8545 18.3203L94.1341 27.4214L102.617 27.1608L102.337 18.0597Z" fill="#E25F26"/>
</g>
</g>
</g>
</g>
<path id="Vector_12" d="M104.662 18.9261H105.569C105.823 18.9294 107.264 19.0498 107.317 20.9191C107.374 22.7348 106.027 22.7515 105.562 22.7515H104.652L104.659 18.9228L104.662 18.9261ZM104.662 18.5215H103.385L103.372 27.0283H104.652L104.659 23.2063C105.997 23.2063 108.702 23.3735 108.705 20.9224C108.708 18.5583 106.15 18.5215 104.779 18.5215H104.666" fill="#E25F26"/>
<g id="Group_8">
<path id="Vector_13" d="M104.656 22.7519L104.662 18.9265H105.569C105.823 18.9265 107.267 19.0469 107.321 20.9195C107.374 22.7118 106.06 22.7519 105.579 22.7519H104.656ZM103.372 27.0254H104.649L104.656 23.2033C105.993 23.2033 108.702 23.3705 108.705 20.9195C108.708 18.5553 106.147 18.5186 104.779 18.5186H103.388L103.375 27.0254H103.372Z" fill="#E25F26"/>
<g id="Clip path group_4">
<mask id="mask3_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="103" y="18" width="6" height="10">
<g id="clippath-3">
<path id="Vector_14" d="M104.656 22.7519L104.662 18.9265H105.569C105.823 18.9265 107.267 19.0469 107.321 20.9195C107.374 22.7118 106.06 22.7519 105.579 22.7519H104.656ZM103.372 27.0254H104.649L104.656 23.2033C105.993 23.2033 108.702 23.3705 108.705 20.9195C108.708 18.5553 106.147 18.5186 104.779 18.5186H103.388L103.375 27.0254H103.372Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask3_22237_352244)">
<g id="Group_9">
<path id="Vector_15" d="M108.698 18.3468L103.109 18.5195L103.377 27.1928L108.966 27.0201L108.698 18.3468Z" fill="#E25F26"/>
</g>
</g>
</g>
</g>
<path id="Vector_16" d="M109.632 18.5283L109.618 27.0385L114.975 27.0452V26.6038L110.899 26.5971L110.902 22.8653L114.306 22.872V22.347L110.902 22.3437L110.909 18.9697L114.985 18.9797L114.988 18.5384L109.632 18.5283Z" fill="#E25F26"/>
<g id="Group_10">
<path id="Vector_17" d="M109.618 27.0385L114.975 27.0452V26.6038L110.899 26.5971L110.906 22.8653L114.306 22.872V22.347L110.906 22.3437L110.909 18.9697L114.988 18.9797V18.5384L109.632 18.5283L109.618 27.0385Z" fill="#E25F26"/>
<g id="Clip path group_5">
<mask id="mask4_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="109" y="18" width="6" height="10">
<g id="clippath-4">
<path id="Vector_18" d="M109.618 27.0385L114.975 27.0452V26.6038L110.899 26.5971L110.906 22.8653L114.306 22.872V22.347L110.906 22.3437L110.909 18.9697L114.988 18.9797V18.5384L109.632 18.5283L109.618 27.0385Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask4_22237_352244)">
<g id="Group_11">
<path id="Vector_19" d="M114.98 18.3731L109.355 18.5449L109.62 27.2183L115.245 27.0464L114.98 18.3731Z" fill="#E25F26"/>
</g>
</g>
</g>
</g>
<path id="Vector_20" d="M117.309 18.9465H118.225C118.483 18.9465 119.91 19.0769 119.967 20.926C119.967 21.1233 119.954 21.334 119.92 21.5179C119.884 21.6717 119.84 21.8222 119.767 21.9626C119.72 22.0797 119.64 22.1934 119.556 22.287C119.476 22.3806 119.392 22.4509 119.302 22.5177C119.115 22.6348 118.894 22.7016 118.67 22.7384C118.519 22.7618 118.369 22.7719 118.218 22.7719H117.299L117.305 18.9465H117.309ZM117.309 18.5385H116.031L116.018 27.0454H117.299L117.305 23.2233C117.586 23.2233 117.911 23.2233 118.262 23.2133L120.974 27.0521H122.405L119.576 23.1096C120.529 22.8655 121.355 22.287 121.358 20.926C121.362 18.5753 118.804 18.5385 117.433 18.5352H117.319" fill="#E25F26"/>
<g id="Group_12">
<path id="Vector_21" d="M117.299 22.7715L117.306 18.946H118.222C118.48 18.946 119.911 19.0765 119.964 20.9256C119.964 21.1229 119.951 21.3336 119.917 21.5175C119.884 21.6713 119.837 21.8218 119.767 21.9589C119.72 22.0759 119.637 22.193 119.556 22.2866C119.476 22.3769 119.396 22.4504 119.302 22.5173C119.115 22.6344 118.894 22.7012 118.674 22.7347C118.523 22.7581 118.373 22.7715 118.222 22.7715H117.303H117.299ZM116.015 27.0483H117.292L117.299 23.2262C117.58 23.2262 117.904 23.2262 118.252 23.2128L120.964 27.055H122.395L119.566 23.1125C120.519 22.8684 121.345 22.2899 121.349 20.929C121.352 18.5749 118.791 18.5414 117.423 18.5381H116.029L116.015 27.0449V27.0483Z" fill="#E25F26"/>
<g id="Clip path group_6">
<mask id="mask5_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="116" y="18" width="7" height="10">
<g id="clippath-5">
<path id="Vector_22" d="M117.299 22.7715L117.306 18.946H118.222C118.48 18.946 119.911 19.0765 119.964 20.9256C119.964 21.1229 119.951 21.3336 119.917 21.5175C119.884 21.6713 119.837 21.8218 119.767 21.9589C119.72 22.0759 119.637 22.193 119.556 22.2866C119.476 22.3769 119.396 22.4504 119.302 22.5173C119.115 22.6344 118.894 22.7012 118.674 22.7347C118.523 22.7581 118.373 22.7715 118.222 22.7715H117.303H117.299ZM116.015 27.0483H117.292L117.299 23.2262C117.58 23.2262 117.904 23.2262 118.252 23.2128L120.964 27.055H122.395L119.566 23.1125C120.519 22.8684 121.345 22.2899 121.349 20.929C121.352 18.5749 118.791 18.5414 117.423 18.5381H116.029L116.015 27.0449V27.0483Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask5_22237_352244)">
<g id="Group_13">
<path id="Vector_23" d="M122.402 18.3455L115.754 18.5498L116.022 27.2565L122.67 27.0523L122.402 18.3455Z" fill="#E25F26"/>
</g>
</g>
</g>
</g>
<path id="Vector_24" d="M121.944 18.5479V19.0695L124.766 19.0762L124.753 27.0614H126.03L126.043 19.0795L128.856 19.0829V18.5579L121.944 18.5479Z" fill="#E25F26"/>
<g id="Group_14">
<path id="Vector_25" d="M121.944 19.0695L124.763 19.0762L124.753 27.0614H126.03L126.043 19.0795L128.856 19.0829V18.5579L121.944 18.5479V19.0695Z" fill="#E25F26"/>
<g id="Clip path group_7">
<mask id="mask6_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="121" y="18" width="8" height="10">
<g id="clippath-6">
<path id="Vector_26" d="M121.944 19.0695L124.763 19.0762L124.753 27.0614H126.03L126.043 19.0795L128.856 19.0829V18.5579L121.944 18.5479V19.0695Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask6_22237_352244)">
<g id="Group_15">
<path id="Vector_27" d="M128.854 18.3274L121.671 18.5469L121.938 27.2704L129.121 27.0509L128.854 18.3274Z" fill="#E25F26"/>
</g>
</g>
</g>
</g>
<path id="Vector_28" d="M136.847 18.5686L134.142 22.812L131.327 18.5619L129.778 18.5586L133.105 23.551L133.102 27.0755H134.38L134.383 23.4039L137.473 18.572L136.847 18.5686Z" fill="#E25F26"/>
<g id="Group_16">
<path id="Vector_29" d="M133.109 23.551L133.099 27.0721L134.38 27.0755L134.386 23.4039L137.473 18.572H136.844L134.146 22.8087L131.327 18.5619L129.782 18.5586L133.109 23.551Z" fill="#E25F26"/>
<g id="Clip path group_8">
<mask id="mask7_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="129" y="18" width="9" height="10">
<g id="clippath-7">
<path id="Vector_30" d="M133.109 23.551L133.099 27.0721L134.38 27.0755L134.386 23.4039L137.473 18.572H136.844L134.146 22.8087L131.327 18.5619L129.782 18.5586L133.109 23.551Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask7_22237_352244)">
<g id="Group_17">
<path id="Vector_31" d="M137.47 18.3149L129.508 18.5596L129.777 27.3064L137.738 27.0618L137.47 18.3149Z" fill="#E25F26"/>
</g>
</g>
</g>
</g>
<path id="Vector_32" d="M141.298 20.6252C141.298 22.0765 142.793 22.8221 143.676 23.2803C145.07 24.0025 145.799 24.4907 145.799 25.3836C145.799 25.8049 145.475 26.7579 144.114 26.7546C143.348 26.7546 142.024 26.4001 141.77 24.8084H141.389C141.629 26.5506 142.653 27.2394 144.244 27.2428C146.257 27.2428 146.906 25.7815 146.909 24.8987C146.909 23.8888 146.428 23.1666 144.401 22.15C143.335 21.6016 142.302 21.0532 142.302 20.1938C142.302 19.4615 143.071 18.8797 143.79 18.883C145.254 18.883 145.719 19.8494 145.89 20.4914H146.307C146.077 19.2709 145.405 18.4082 143.78 18.4082C143.127 18.4082 141.302 18.7727 141.298 20.6252Z" fill="#E25F26"/>
<g id="Group_18">
<path id="Vector_33" d="M141.298 20.6252C141.292 22.0798 142.79 22.8255 143.676 23.2803C145.07 24.0025 145.799 24.4907 145.799 25.3836C145.799 25.8049 145.475 26.7579 144.114 26.7546C143.348 26.7546 142.024 26.4001 141.77 24.8118H141.389C141.629 26.5539 142.649 27.2394 144.244 27.2428C146.257 27.2461 146.909 25.7815 146.909 24.8987C146.909 23.8888 146.425 23.1666 144.401 22.1534C143.335 21.605 142.302 21.0566 142.305 20.1938C142.305 19.4649 143.074 18.883 143.793 18.8864C145.258 18.8864 145.722 19.8528 145.893 20.4914H146.314C146.083 19.2743 145.411 18.4082 143.783 18.4082C143.131 18.4082 141.305 18.776 141.305 20.6252" fill="#E25F26"/>
<g id="Clip path group_9">
<mask id="mask8_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="141" y="18" width="6" height="10">
<g id="clippath-8">
<path id="Vector_34" d="M141.298 20.6252C141.292 22.0798 142.79 22.8255 143.676 23.2803C145.07 24.0025 145.799 24.4907 145.799 25.3836C145.799 25.8049 145.475 26.7579 144.114 26.7546C143.348 26.7546 142.024 26.4001 141.77 24.8118H141.389C141.629 26.5539 142.649 27.2394 144.244 27.2428C146.257 27.2461 146.909 25.7815 146.909 24.8987C146.909 23.8888 146.425 23.1666 144.401 22.1534C143.335 21.605 142.302 21.0566 142.305 20.1938C142.305 19.4649 143.074 18.883 143.793 18.8864C145.258 18.8864 145.722 19.8528 145.893 20.4914H146.314C146.083 19.2743 145.411 18.4082 143.783 18.4082C143.131 18.4082 141.305 18.776 141.305 20.6252" fill="white"/>
</g>
</mask>
<g mask="url(#mask8_22237_352244)">
<g id="Group_19">
<path id="Vector_35" d="M146.908 18.2389L141.016 18.4199L141.292 27.4241L147.185 27.2431L146.908 18.2389Z" fill="#E25F26"/>
</g>
</g>
</g>
</g>
<path id="Vector_36" d="M153.51 18.5956L153.503 22.5714L149.226 22.5648L149.233 18.5889H147.956L147.942 27.0957L149.22 27.0991L149.226 23.0062L153.503 23.0128L153.5 27.1058L154.777 27.1091L154.787 18.5989L153.51 18.5956Z" fill="#E25F26"/>
<g id="Group_20">
<path id="Vector_37" d="M147.956 18.5889L147.942 27.0957L149.22 27.0991L149.226 23.0062L153.503 23.0128L153.497 27.1058L154.777 27.1091L154.787 18.5989L153.51 18.5956L153.507 22.5714L149.226 22.5681L149.233 18.5889H147.956Z" fill="#E25F26"/>
<g id="Clip path group_10">
<mask id="mask9_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="147" y="18" width="8" height="10">
<g id="clippath-9">
<path id="Vector_38" d="M147.956 18.5889L147.942 27.0957L149.22 27.0991L149.226 23.0062L153.503 23.0128L153.497 27.1058L154.777 27.1091L154.787 18.5989L153.51 18.5956L153.507 22.5714L149.226 22.5681L149.233 18.5889H147.956Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask9_22237_352244)">
<g id="Group_21">
<path id="Vector_39" d="M154.783 18.3684L147.681 18.5879L147.95 27.3079L155.053 27.0885L154.783 18.3684Z" fill="#E25F26"/>
</g>
</g>
</g>
</g>
<path id="Vector_40" d="M157.101 22.8315C157.105 20.1229 158.329 18.7988 159.813 18.8021C161.315 18.8021 162.519 20.1096 162.515 22.8382C162.509 25.6504 161.301 26.8676 159.8 26.8676C158.312 26.8676 157.095 25.6437 157.098 22.8315M155.707 22.8315C155.7 25.9112 157.536 27.2622 159.803 27.2655C162.07 27.2688 163.91 25.9246 163.913 22.8449C163.92 19.8454 162.084 18.4242 159.817 18.4209C157.55 18.4176 155.71 19.8554 155.707 22.8315Z" fill="#E25F26"/>
<g id="Group_22">
<path id="Vector_41" d="M157.101 22.8315C157.108 20.1263 158.329 18.8021 159.813 18.8021C161.315 18.8021 162.522 20.1096 162.518 22.8382C162.512 25.6471 161.305 26.8676 159.81 26.8676H159.803C158.315 26.8676 157.098 25.6471 157.101 22.8315ZM159.803 18.4209C157.543 18.4209 155.707 19.8588 155.704 22.8315C155.697 25.9112 157.533 27.2622 159.8 27.2655C162.067 27.2688 163.906 25.9279 163.91 22.8449C163.916 19.8454 162.08 18.4242 159.813 18.4242H159.803V18.4209Z" fill="#E25F26"/>
<g id="Clip path group_11">
<mask id="mask10_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="155" y="18" width="9" height="10">
<g id="clippath-10">
<path id="Vector_42" d="M157.101 22.8315C157.108 20.1263 158.329 18.8021 159.813 18.8021C161.315 18.8021 162.522 20.1096 162.518 22.8382C162.512 25.6471 161.305 26.8676 159.81 26.8676H159.803C158.315 26.8676 157.098 25.6471 157.101 22.8315ZM159.803 18.4209C157.543 18.4209 155.707 19.8588 155.704 22.8315C155.697 25.9112 157.533 27.2622 159.8 27.2655C162.067 27.2688 163.906 25.9279 163.91 22.8449C163.916 19.8454 162.08 18.4242 159.813 18.4242H159.803V18.4209Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask10_22237_352244)">
<g id="Group_23">
<path id="Vector_43" d="M163.909 18.1544L155.426 18.415L155.706 27.5162L164.189 27.2555L163.909 18.1544Z" fill="#E25F26"/>
</g>
</g>
</g>
</g>
<path id="Vector_44" d="M166.237 19.0232H167.14C167.397 19.0265 168.839 19.1436 168.892 21.0161C168.946 22.8285 167.598 22.8486 167.133 22.8486H166.227L166.234 19.0198L166.237 19.0232ZM166.237 18.6152H164.956L164.943 27.1221H166.22L166.227 23.3C167.561 23.3 170.273 23.4672 170.276 21.0161C170.28 18.652 167.718 18.6152 166.347 18.6152H166.234" fill="#E25F26"/>
<g id="Group_24">
<path id="Vector_45" d="M166.23 22.8486L166.237 19.0232H167.14C167.397 19.0265 168.839 19.1436 168.892 21.0161C168.946 22.8319 167.598 22.8519 167.133 22.8519H166.227L166.23 22.8486ZM164.943 27.1221H166.22L166.227 23.3C167.561 23.3 170.273 23.4706 170.273 21.0161C170.28 18.6554 167.715 18.6186 166.347 18.6152H164.956L164.943 27.1221Z" fill="#E25F26"/>
<g id="Clip path group_12">
<mask id="mask11_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="164" y="18" width="7" height="10">
<g id="clippath-11">
<path id="Vector_46" d="M166.23 22.8486L166.237 19.0232H167.14C167.397 19.0265 168.839 19.1436 168.892 21.0161C168.946 22.8319 167.598 22.8519 167.133 22.8519H166.227L166.23 22.8486ZM164.943 27.1221H166.22L166.227 23.3C167.561 23.3 170.273 23.4706 170.273 21.0161C170.28 18.6554 167.715 18.6186 166.347 18.6152H164.956L164.943 27.1221Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask11_22237_352244)">
<g id="Group_25">
<path id="Vector_47" d="M170.274 18.4639L164.682 18.6357L164.949 27.309L170.54 27.1372L170.274 18.4639Z" fill="#E25F26"/>
</g>
</g>
</g>
</g>
<path id="Vector_48" d="M101.847 31.834H101.021V37.8597H101.847V31.834Z" fill="#272963"/>
<g id="Group_26">
<path id="Vector_49" d="M101.847 31.834H101.021V37.8597H101.847V31.834Z" fill="#272963"/>
<g id="Clip path group_13">
<mask id="mask12_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="101" y="31" width="1" height="7">
<g id="clippath-12">
<path id="Vector_50" d="M101.847 31.834H101.021V37.8597H101.847V31.834Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask12_22237_352244)">
<g id="Group_27">
<path id="Vector_51" d="M101.85 31.8044L100.834 31.835L101.016 37.8847L102.032 37.8542L101.85 31.8044Z" fill="#272963"/>
</g>
</g>
</g>
</g>
<path id="Vector_52" d="M107.063 31.8504L107.057 36.1507L102.676 31.8438L102.666 37.8661H103.037L103.041 33.5592L107.424 37.8728L107.434 31.8504H107.063Z" fill="#272963"/>
<g id="Group_28">
<path id="Vector_53" d="M102.666 37.8628H103.037L103.041 33.5558L107.424 37.8694L107.434 31.8504H107.063L107.06 36.1507L102.673 31.8438L102.666 37.8628Z" fill="#272963"/>
<g id="Clip path group_14">
<mask id="mask13_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="102" y="31" width="6" height="7">
<g id="clippath-13">
<path id="Vector_54" d="M102.666 37.8628H103.037L103.041 33.5558L107.424 37.8694L107.434 31.8504H107.063L107.06 36.1507L102.673 31.8438L102.666 37.8628Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask13_22237_352244)">
<g id="Group_29">
<path id="Vector_55" d="M107.43 31.709L102.48 31.8594L102.667 38.026L107.617 37.8756L107.43 31.709Z" fill="#272963"/>
</g>
</g>
</g>
</g>
<path id="Vector_56" d="M113.049 31.8504L111.009 36.5118L109 31.8438H108.1L110.551 37.5384L110.752 37.9999L111.207 36.9733L113.46 31.8504H113.049Z" fill="#272963"/>
<g id="Group_30">
<path id="Vector_57" d="M108.1 31.8438L110.551 37.5384L110.748 37.9999L111.207 36.9733L113.46 31.8504H113.049L111.009 36.5118L109 31.8438H108.1Z" fill="#272963"/>
<g id="Clip path group_15">
<mask id="mask14_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="108" y="31" width="6" height="7">
<g id="clippath-14">
<path id="Vector_58" d="M108.1 31.8438L110.551 37.5384L110.748 37.9999L111.207 36.9733L113.46 31.8504H113.049L111.009 36.5118L109 31.8438H108.1Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask14_22237_352244)">
<g id="Group_31">
<path id="Vector_59" d="M113.453 31.6771L107.901 31.8477L108.095 38.1646L113.647 37.994L113.453 31.6771Z" fill="#272963"/>
</g>
</g>
</g>
</g>
<path id="Vector_60" d="M114.129 31.8535L114.119 37.8826L117.914 37.8892V37.5749L115.025 37.5716L115.029 34.9266L117.443 34.9299V34.5587L115.029 34.5554L115.032 32.1678L117.924 32.1745V31.8602L114.129 31.8535Z" fill="#272963"/>
<g id="Group_32">
<path id="Vector_61" d="M114.119 37.883L117.914 37.8897V37.5753L115.025 37.572L115.029 34.927L117.443 34.9303V34.5591L115.029 34.5558L115.035 32.1683L117.924 32.1749V31.8606L114.129 31.8506L114.119 37.883Z" fill="#272963"/>
<g id="Clip path group_16">
<mask id="mask15_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="114" y="31" width="4" height="7">
<g id="clippath-15">
<path id="Vector_62" d="M114.119 37.883L117.914 37.8897V37.5753L115.025 37.572L115.029 34.927L117.443 34.9303V34.5591L115.029 34.5558L115.035 32.1683L117.924 32.1749V31.8606L114.129 31.8506L114.119 37.883Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask15_22237_352244)">
<g id="Group_33">
<path id="Vector_63" d="M117.921 31.7444L113.934 31.8662L114.121 38.0094L118.109 37.8876L117.921 31.7444Z" fill="#272963"/>
</g>
</g>
</g>
</g>
<path id="Vector_64" d="M118.586 33.3115C118.586 34.3414 119.646 34.8697 120.272 35.1941C121.258 35.7023 121.78 36.0534 121.776 36.6854C121.776 36.983 121.542 37.6552 120.579 37.6552C120.034 37.6552 119.098 37.4077 118.921 36.2775H118.647C118.817 37.5114 119.539 37.9996 120.67 37.9996C122.094 37.9996 122.559 36.963 122.559 36.341C122.559 35.6254 122.215 35.1138 120.783 34.3949C120.028 34.007 119.295 33.6191 119.295 33.0105C119.295 32.4922 119.84 32.0809 120.352 32.0809C121.389 32.0809 121.716 32.7664 121.84 33.2212H122.138C121.974 32.3551 121.496 31.7432 120.345 31.7432C119.884 31.7432 118.59 32.004 118.59 33.3148" fill="#272963"/>
<g id="Group_34">
<path id="Vector_65" d="M118.586 33.3087C118.586 34.3419 119.646 34.8669 120.272 35.1913C121.258 35.7029 121.776 36.0507 121.776 36.6827C121.776 36.9803 121.546 37.6524 120.579 37.6524C120.038 37.6524 119.098 37.4049 118.921 36.278H118.647C118.82 37.5119 119.543 38.0001 120.67 38.0001C122.094 38.0035 122.559 36.9635 122.559 36.3416C122.559 35.626 122.215 35.1144 120.783 34.3954C120.028 34.0075 119.292 33.6197 119.295 33.0111C119.295 32.4928 119.837 32.0848 120.352 32.0848C121.389 32.0848 121.716 32.767 121.84 33.2217H122.138C121.974 32.359 121.499 31.7471 120.345 31.7471H120.342C119.874 31.7471 118.593 32.0112 118.59 33.3154" fill="#272963"/>
<g id="Clip path group_17">
<mask id="mask16_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="118" y="31" width="5" height="7">
<g id="clippath-16">
<path id="Vector_66" d="M118.586 33.3087C118.586 34.3419 119.646 34.8669 120.272 35.1913C121.258 35.7029 121.776 36.0507 121.776 36.6827C121.776 36.9803 121.546 37.6524 120.579 37.6524C120.038 37.6524 119.098 37.4049 118.921 36.278H118.647C118.82 37.5119 119.543 38.0001 120.67 38.0001C122.094 38.0035 122.559 36.9635 122.559 36.3416C122.559 35.626 122.215 35.1144 120.783 34.3954C120.028 34.0075 119.292 33.6197 119.295 33.0111C119.295 32.4928 119.837 32.0848 120.352 32.0848C121.389 32.0848 121.716 32.767 121.84 33.2217H122.138C121.974 32.359 121.499 31.7471 120.345 31.7471H120.342C119.874 31.7471 118.593 32.0112 118.59 33.3154" fill="white"/>
</g>
</mask>
<g mask="url(#mask16_22237_352244)">
<g id="Group_35">
<path id="Vector_67" d="M122.567 31.6098L118.392 31.7373L118.587 38.1178L122.762 37.9903L122.567 31.6098Z" fill="#272963"/>
</g>
</g>
</g>
</g>
<path id="Vector_68" d="M122.652 31.8672V32.2384L124.655 32.2417L124.645 37.8996H125.551L125.558 32.2417L127.554 32.245V31.8739L122.652 31.8672Z" fill="#272963"/>
<g id="Group_36">
<path id="Vector_69" d="M122.652 32.2384L124.652 32.2417L124.645 37.8962L125.551 37.8996L125.558 32.2417L127.554 32.245V31.8739L122.656 31.8672L122.652 32.2384Z" fill="#272963"/>
<g id="Clip path group_18">
<mask id="mask17_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="122" y="31" width="6" height="7">
<g id="clippath-17">
<path id="Vector_70" d="M122.652 32.2384L124.652 32.2417L124.645 37.8962L125.551 37.8996L125.558 32.2417L127.554 32.245V31.8739L122.656 31.8672L122.652 32.2384Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask17_22237_352244)">
<g id="Group_37">
<path id="Vector_71" d="M127.551 31.7119L122.464 31.8682L122.654 38.0481L127.741 37.8918L127.551 31.7119Z" fill="#272963"/>
</g>
</g>
</g>
</g>
<path id="Vector_72" d="M131.367 36.5584L128.912 31.877L128.21 37.9026H128.581L129.033 34.0438L131.076 37.9093L133.323 33.7796L134.035 37.9127H134.914L134.945 37.906L133.918 31.887L131.367 36.5584Z" fill="#272963"/>
<g id="Group_38">
<path id="Vector_73" d="M128.21 37.906H128.581L129.033 34.0438L131.076 37.9093L133.323 33.7763L134.032 37.9127H134.914L134.948 37.906L133.921 31.8836L131.367 36.5584L128.912 31.877L128.21 37.906Z" fill="#272963"/>
<g id="Clip path group_19">
<mask id="mask18_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="128" y="31" width="7" height="7">
<g id="clippath-18">
<path id="Vector_74" d="M128.21 37.906H128.581L129.033 34.0438L131.076 37.9093L133.323 33.7763L134.032 37.9127H134.914L134.948 37.906L133.921 31.8836L131.367 36.5584L128.912 31.877L128.21 37.906Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask18_22237_352244)">
<g id="Group_39">
<path id="Vector_75" d="M134.946 31.6723L128.024 31.8838L128.214 38.1206L135.136 37.9091L134.946 31.6723Z" fill="#272963"/>
</g>
</g>
</g>
</g>
<path id="Vector_76" d="M135.623 31.8867L135.617 37.9158L139.412 37.9224V37.6081L136.52 37.6048L136.526 34.9598L138.941 34.9631V34.5919L136.526 34.5886L136.53 32.201L139.419 32.2044V31.8934L135.623 31.8867Z" fill="#272963"/>
<g id="Group_40">
<path id="Vector_77" d="M135.613 37.9158L139.412 37.9224V37.6081L136.519 37.6048L136.523 34.9598L138.94 34.9631V34.5919L136.523 34.5886L136.526 32.201L139.419 32.2077V31.8934L135.623 31.8867L135.613 37.9158Z" fill="#272963"/>
<g id="Clip path group_20">
<mask id="mask19_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="135" y="31" width="5" height="7">
<g id="clippath-19">
<path id="Vector_78" d="M135.613 37.9158L139.412 37.9224V37.6081L136.519 37.6048L136.523 34.9598L138.94 34.9631V34.5919L136.523 34.5886L136.526 32.201L139.419 32.2077V31.8934L135.623 31.8867L135.613 37.9158Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask19_22237_352244)">
<g id="Group_41">
<path id="Vector_79" d="M139.416 31.7766L135.429 31.8984L135.616 38.0416L139.604 37.9198L139.416 31.7766Z" fill="#272963"/>
</g>
</g>
</g>
</g>
<path id="Vector_80" d="M144.558 31.9071L144.548 36.2073L140.168 31.9004L140.161 37.9227H140.529L140.536 33.6158L144.919 37.9294L144.93 31.9071H144.558Z" fill="#272963"/>
<g id="Group_42">
<path id="Vector_81" d="M140.161 37.9227H140.529L140.536 33.6125L144.919 37.9294L144.926 31.9104H144.555L144.548 36.2073L140.168 31.9004L140.161 37.9227Z" fill="#272963"/>
<g id="Clip path group_21">
<mask id="mask20_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="140" y="31" width="5" height="7">
<g id="clippath-20">
<path id="Vector_82" d="M140.161 37.9227H140.529L140.536 33.6125L144.919 37.9294L144.926 31.9104H144.555L144.548 36.2073L140.168 31.9004L140.161 37.9227Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask20_22237_352244)">
<g id="Group_43">
<path id="Vector_83" d="M144.925 31.7454L139.978 31.8965L140.166 38.0631L145.113 37.912L144.925 31.7454Z" fill="#272963"/>
</g>
</g>
</g>
</g>
<path id="Vector_84" d="M145.595 31.9033V32.2711L147.595 32.2745L147.585 37.9324L148.491 37.9357L148.501 32.2778L150.494 32.2812V31.91L145.595 31.9033Z" fill="#272963"/>
<g id="Group_44">
<path id="Vector_85" d="M145.595 32.2749H147.595L147.585 37.9361H148.491L148.501 32.2782L150.494 32.2816V31.9104L145.595 31.9004V32.2749Z" fill="#272963"/>
<g id="Clip path group_22">
<mask id="mask21_22237_352244" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="145" y="31" width="6" height="7">
<g id="clippath-21">
<path id="Vector_86" d="M145.595 32.2749H147.595L147.585 37.9361H148.491L148.501 32.2782L150.494 32.2816V31.9104L145.595 31.9004V32.2749Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask21_22237_352244)">
<g id="Group_45">
<path id="Vector_87" d="M150.491 31.746L145.404 31.9023L145.594 38.0823L150.681 37.926L150.491 31.746Z" fill="#272963"/>
</g>
</g>
</g>
</g>
</g>
<g id="Group_46">
<path id="Vector_88" d="M55.5737 16.2881V17.1542C57.9411 18.0068 58.3023 19.8995 58.2956 24.9053L58.2387 62.076C58.232 66.3361 61.6796 69.7937 65.9364 69.8004H66.4346L66.5048 24.9187C66.5115 19.8426 66.876 17.96 69.3171 17.1307V16.3081L55.5703 16.2881H55.5737Z" fill="#272963"/>
<path id="Vector_89" d="M27.5555 27.9446C25.6796 28.6435 23.9475 29.6901 22.4561 31.0244C21.055 32.295 19.9214 33.8366 19.1256 35.5553C17.4469 39.4342 17.5239 43.8482 19.3396 47.6669C20.2926 49.5763 21.677 51.2348 23.3857 52.5189C25.1446 53.9133 28.3882 55.8762 33.1164 58.4042C34.9422 59.3471 36.7178 60.3837 38.4366 61.5073C39.8109 62.3734 41.1083 63.3598 42.3121 64.4466C43.1347 65.1588 43.8002 66.0316 44.265 67.0113C44.6161 67.8306 44.7933 68.7134 44.7933 69.6028C44.7933 70.6194 44.5559 71.6192 44.0911 72.5221C43.6096 73.465 42.9608 74.3111 42.1717 75.02C41.7704 75.3811 41.3324 75.7021 40.8709 75.983C51.4911 76.3408 53.8452 67.6166 50.2104 61.2732C48.0904 57.5682 43.2651 55.0268 39.6437 52.8198C38.4198 52.0742 38.1858 51.917 36.8683 51.1212C35.5508 50.3286 34.3403 49.6097 33.2067 48.9443C32.0898 48.2722 31.1402 47.697 30.351 47.2289C29.5619 46.7473 29.0803 46.4497 28.8931 46.3427C27.5856 45.3697 26.4922 44.1424 25.6696 42.7347C25.0041 41.5676 24.6497 40.2535 24.6363 38.9093C24.6363 37.8191 24.8771 36.7458 25.3385 35.7593C25.8167 34.7428 26.4989 33.8332 27.3482 33.0875C28.2945 32.285 29.388 31.6697 30.565 31.2785C31.9427 30.8103 33.3839 30.583 34.8385 30.5997C37.4367 30.5662 40.0015 31.1782 42.3021 32.382C43.3621 32.927 44.3486 33.5958 45.2481 34.3749C46.0807 35.1006 46.7963 35.9533 47.3681 36.8929C48.0068 37.9797 48.505 39.1467 48.8561 40.3572C49.331 41.9422 49.7021 43.5539 49.9663 45.1891H51.6784L51.7085 26.8378H49.993C49.9395 27.6738 49.6553 28.4797 49.1671 29.1618C48.7759 29.5597 48.2308 29.767 47.6757 29.7336C47.1173 29.6901 46.5622 29.5898 46.0272 29.4226C45.2648 29.2053 44.285 28.9043 43.0779 28.5499C39.8142 27.5835 36.8382 26.7743 33.7484 26.7676C31.7621 26.7676 29.7291 27.0953 27.5455 27.9346" fill="#272963"/>
<path id="Vector_90" d="M19.0017 0.030095L0.469828 0V0.896163C1.15198 1.17036 1.73382 1.49138 2.1819 2.02306C2.91087 2.90919 3.26198 5.91535 3.25863 9.0051L3.19844 46.1758C3.1951 49.0449 2.89749 52.1948 2.32234 53.0341C1.8542 53.723 1.19545 54.044 0.38623 54.375V55.1742L13.725 55.1943C13.4609 54.7797 13.2167 54.3483 12.9961 53.9069C12.5078 52.9238 12.1434 51.8838 11.916 50.8105C11.5682 49.2957 11.4177 47.7408 11.4779 46.1892L11.5114 26.4L11.5481 3.33386C13.7585 2.7654 16.0356 2.4912 18.3162 2.5213C20.4128 2.49454 22.4994 2.79215 24.5057 3.40408C26.1309 3.89229 27.649 4.69148 28.9732 5.75484C30.1201 6.67775 31.043 7.85146 31.6684 9.18902C33.2768 12.6734 32.9858 16.9234 30.0833 19.5751C35.0925 23.2635 38.413 21.7186 39.7673 17.9935C41.2252 13.7902 40.3491 9.12883 37.4633 5.73812C36.6173 4.75167 35.6376 3.88895 34.5508 3.17335C33.3637 2.41095 32.073 1.81908 30.7187 1.41447C29.0568 0.922914 27.3514 0.57515 25.6293 0.381204C23.5661 0.150475 21.4929 0.030095 19.4163 0.0267511C19.2792 0.0267511 19.1421 0.0267511 19.005 0.0267511" fill="#272963"/>
<path id="Vector_91" d="M72.9453 63.9791C72.9386 67.3665 75.6806 70.1185 79.0713 70.1252C82.4587 70.1319 85.2107 67.3899 85.2174 63.9992C85.2241 60.6118 82.4821 57.8631 79.0914 57.8565C75.7007 57.8498 72.952 60.5918 72.9453 63.9825" fill="#E25F26"/>
</g>
</g>
<defs>
<clipPath id="clip0_22237_352244">
<rect width="170.154" height="76" fill="white" transform="translate(0.38623)"/>
</clipPath>
</defs>
</svg>
</div>
<script>
 if (window.location.hostname.includes("psiassets-crm")) {
   document.getElementById("psiAssetsLogo").classList.add("show");
} else {
  document.getElementById("psiInvestmentLogo").classList.add("show");
}
  </script>
<div>
{{{innerHTML}}}
{{#showActionButtons}}
<div class="form_actions actions">
<button id="reject-button" tabindex="0" class="rejectButton" type="button">Reject<span class="MuiTouchRipple-root"></span></button>
<button id="approve-button" class="approveButton" tabindex="0" type="button">Approve<span class="MuiTouchRipple-root"></span></button>
</div>
{{/showActionButtons}}
</div>
</div>
</body>

</html>
`;
